module.exports = __webpack_public_path__ + "static/media/icon-search.2b4143a7.svg";